module.exports = __webpack_public_path__ + "static/media/Manuela_Carmena_MAS_MADRID.801c10c0.png";